import { render, staticRenderFns } from "./MaterialStandardMappingEdit.vue?vue&type=template&id=914c8bf0&scoped=true&"
import script from "./MaterialStandardMappingEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialStandardMappingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "914c8bf0",
  null
  
)

export default component.exports